import { isMobile } from "react-device-detect"
import React, { useState, useContext, useRef, useEffect, useCallback } from "react";
import { ApiService } from "../../Component/services/apiServices";
import constants from "../../Component/services/constants";
import Skeleton from "react-loading-skeleton";
import DataContext from "../../Component/context";
import AddItemModal from "../../Component/Modals/add_Item";
import { useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Tabs, Tab } from "react-tabs-scrollable";
import "react-tabs-scrollable/dist/rts.css";
import Loader from "react-js-loader";
import moment from 'moment-timezone';
import AccountHeader from "../../Component/Header/account_header";
const OrderOnline = () => {
    const timeZone = "Australia/Sydney";
    const featuredItemRef = useRef(null);
    const [productData, setproductData] = useState([]);
    const [popularProduct, setPopularProduct] = useState([]);
    const [isLoadingProducts, setIsLoadingProducts] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [addActive, setaddActive] = useState(0);
    const [ShowScroll, setShowScroll] = useState(false);
    const contentRefs = useRef([]);
    const contextValues = useContext(DataContext);
    const isOrderStop = contextValues?.settingData?.order_stop == 1 || contextValues?.settingData?.order_stop === true;
    const [activeTab, setActiveTab] = useState(0);
    const sectionRefs = useRef([]);
    const [loadingItemId, setLoadingItemId] = useState(null);
    const { slug } = useParams()
    const didMountRef = useRef(true);
    const sliderProdmobRef = useRef(null);
    const [cart, setCart] = useState(() => {
        return JSON.parse(localStorage.getItem('CART_SESSION')) || [];
    });

    const [offset, setOffset] = useState(307.919);
    const [active, setActive] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const progress = scrollTop / docHeight;

            // Calculate stroke offset
            const circleLength = 307.919;
            const newOffset = circleLength - circleLength * progress;
            setOffset(newOffset);

            // Add class when scroll > 100px
            setActive(scrollTop > 100);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    const getPopularItems = useCallback(() => {
        setIsLoading(true)
        ApiService.fetchData("popular-item").then((res) => {
            if (res?.status === "success") {
                setIsLoading(false)
                setPopularProduct(res?.data);
            } else {
                setIsLoading(false)
            }
        }).catch((error) => {
            setIsLoading(false)
        });
    }, []);

    const getProductData = useCallback(() => {
        setIsLoadingProducts(true);
        const dataString = {
            cat_slug: '',
            sort_filter: ""
        }
        ApiService.postData("category-wise-menu", dataString)
            .then((res) => {
                if (res.status === "success") {
                    setproductData(res.categoryData);
                    if (slug) {
                        const index = res.categoryData.findIndex(
                            (item) => item.cat_slug === slug
                        );
                        if (index !== -1) {
                            scrollToContent(index)
                            scrollToContentMobile(index)
                        } else {
                            console.log('No matching item found for the provided slug');
                        }
                    }
                    setIsLoadingProducts(false);
                } else {
                    setIsLoadingProducts(false);
                }
            })
            .catch(() => {
                setIsLoadingProducts(false);
            });
    }, [slug]);

    useEffect(() => {
        if (didMountRef.current) {
            getProductData();
            getPopularItems();
        }
        didMountRef.current = false;
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [getProductData, getPopularItems]);

    const handlePrevmob = useCallback(() => {
        if (!sliderProdmobRef.current) return;
        sliderProdmobRef.current.swiper.slidePrev();
    }, []);

    const handleNextmob = useCallback(() => {
        if (!sliderProdmobRef.current) return;
        sliderProdmobRef.current.swiper.slideNext();
    }, []);

    const handleScroll = () => {
        const offset = 180; // Adjust offset for better accuracy
        contentRefs.current.forEach((ref, index) => {
            if (ref) {
                const rect = ref.getBoundingClientRect();
                if (rect.top <= offset && rect.bottom > offset) {
                    setaddActive(index);
                }
            }
        });
    };

    const scrollToContent = (index) => {
        setTimeout(() => {
            const element = contentRefs.current[index];
            if (element) {
                const topOffset = element.offsetTop - 100;
                window.scrollTo({
                    top: topOffset,
                    behavior: 'smooth',
                });
            }
        }, 100);
    };

    const scrollToContentMobile = (index) => {
        setTimeout(() => {
            const element = sectionRefs.current[index];
            if (element) {
                const topOffset = element.offsetTop - 100;
                window.scrollTo({
                    top: topOffset,
                    behavior: 'smooth',
                });
            }
        }, 100);
    };

    const addItemModal = () => {
        contextValues.setToggleItemAddModal(!contextValues.toggleItemAddModal)
    }

    useEffect(() => {
        if (isMobile) {
            if (!featuredItemRef.current) return; // Prevent running the observer if ref is null
            const observer = new IntersectionObserver(
                ([entry]) => {
                    setShowScroll(!entry.isIntersecting); // Show tabs when `featuredItem` is out of view
                },
                { root: null, threshold: 0.1 }
            );
            observer.observe(featuredItemRef.current);
            return () => {
                if (featuredItemRef.current) {
                    observer.unobserve(featuredItemRef.current);
                }
            };
        }

    }, [featuredItemRef.current]);

    const handleTabClick = (e, index) => {
        setActiveTab(index);
        sectionRefs.current[index]?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        });
    };

    useEffect(() => {
        if (isMobile) {
            if (!sectionRefs.current || sectionRefs.current.length === 0) {
                console.error("sectionRefs.current is empty or not initialized.");
                return;
            }

            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const visibleIndex = Number(entry.target.getAttribute("data-index"));
                            setActiveTab(visibleIndex);
                        }
                    });
                },
                { threshold: 0.5 }
            );
            sectionRefs.current.forEach((section) => {
                if (section) observer.observe(section);
            });
            return () => {
                observer.disconnect();
            };
        }
    }, [productData]);

    const updateCartInSession = (updatedCart) => {
        localStorage.removeItem("CART_SESSION");
        localStorage.removeItem("COUPON_SESSION");
        localStorage.setItem('CART_SESSION', JSON.stringify(updatedCart));
        contextValues.setCartSessionData(updatedCart)
        contextValues.setCartCount(updatedCart.length)
        setCart(updatedCart);
        setTimeout(() => {
            setLoadingItemId(null)
        }, 500);
    };

    const gotocheckout = () => {
        window.location.href = "/choose-meal-date";
    }

    const onModalOpen = async (item) => {
        const cart = JSON.parse(localStorage.getItem('CART_SESSION')) || []
        if (item.product_type === 0) {
            setLoadingItemId(item.product_id)
            const existingItem = cart.find(cartItem => cartItem.product_id === item.product_id);
            let updatedCart;
            if (existingItem) {
                updatedCart = cart.map(cartItem =>
                    cartItem.product_id === item.product_id
                        ? { ...cartItem, quantity: cartItem.quantity + 1 }
                        : cartItem
                );
            } else {
                let today = moment().tz(timeZone).format('YYYY-MM-DD');
                let currentDay = moment().tz(timeZone).format('dddd');
                let uniqueSessionId = crypto.randomUUID();
                let schedule = getScheduleTime(today)
                if (schedule === '') {
                    today = moment().tz(timeZone).add(1, 'day').format('YYYY-MM-DD');
                    currentDay = moment().tz(timeZone).add(1, 'day').format('dddd');
                    schedule = getScheduleTime(today)
                }

                updatedCart = [
                    ...cart,
                    {
                        product_id: item.product_id,
                        product_day: currentDay,
                        product_selected_day: currentDay,
                        product_selected_date: today,
                        product_uniqueid: item.product_uniqueid,
                        product_name: item.product_name,
                        product_image: item.product_image,
                        product_price: item.product_price,
                        product_selling_price: item.product_selling_price,
                        product_discount: item.product_discounts,
                        product_type: item.product_type,
                        product_category_name: item.product_category_name,
                        product_tiffin_items: {},
                        product_slug: item?.product_slug,
                        addon_amount: 0,
                        addon_item_names: item.product_category_name,
                        quantity: 1,
                        product_sesion_id: uniqueSessionId,
                        product_time: schedule,
                    },
                ];
            }
            updateCartInSession(updatedCart);
        } else {
            contextValues.setSelectedProduct(item);
            addItemModal();
        }
    };

    const getScheduleTime = (newDate = moment().tz(timeZone).format("YYYY-MM-DD")) => {
        const today = moment().tz(timeZone).format('YYYY-MM-DD');
        const selectedDate = newDate;

        if (today !== selectedDate) {
            contextValues.setMenuSchedule('lunch');
            return 'lunch';
        }

        if (!contextValues?.settingData) {
            contextValues.setMenuSchedule('lunch');
            return 'lunch';
        }

        const { lunch_end_time, dinner_end_time, pickup_lunch_end_time, pickup_dinner_end_time } = contextValues.settingData;
        const currentTime = moment().tz(timeZone).format('HH:mm:ss');

        const isDelivery = contextValues.orderRecieveStatus === 'delivery';
        const lunchEnd = isDelivery ? lunch_end_time : pickup_lunch_end_time;
        const dinnerEnd = isDelivery ? dinner_end_time : pickup_dinner_end_time;

        const schedule = currentTime < lunchEnd ? 'lunch' : currentTime < dinnerEnd ? 'dinner' : '';
        contextValues.setMenuSchedule(schedule);
        return schedule;
    };

    const ItemButton = ({ item, cart, onModalOpen, updateCart }) => {
        const existingItem = cart.find(cartItem => cartItem.product_id === item.product_id);
        const handleAddToCart = () => {
            onModalOpen(item);
        };

        const handleRemoveFromCart = () => {
            let updatedCart = [...cart];
            setLoadingItemId(item.product_id)
            if (existingItem) {
                if (existingItem.quantity > 1) {
                    updatedCart = cart.map(cartItem =>
                        cartItem.product_id === item.product_id
                            ? { ...cartItem, quantity: cartItem.quantity - 1 }
                            : cartItem
                    );
                } else {
                    updatedCart = updatedCart.filter(cartItem => cartItem.product_id !== item.product_id);
                }
                updateCart(updatedCart);
            }
        };

        return (
            existingItem && item.product_type === 0 ? (
                <>
                    <span onClick={handleRemoveFromCart}><i className="ri-subtract-line"></i></span>
                    <span>{existingItem.quantity}</span>
                    <span onClick={handleAddToCart}><i className="ri-add-line"></i></span>
                </>
            ) : (
                <>
                    {item.product_type === 1 ? <><span onClick={handleAddToCart}>ADD</span>
                        <span className="plusicon"><i className="ri-add-line"></i></span></>
                        : <span onClick={handleAddToCart}>ADD</span>}
                </>
            )
        );
    };

    const onChangeRecieveStaus = (type) => {
        localStorage.setItem('OrderRecieveStatus', type);
        contextValues.setorderRecieveStatus(type);
    };

    const sellingPrice = (item) => {
        if (item.product_type === 1) {
            if (item.has_many_cs_product_week_day.length > 0) {
                const day = moment().tz(timeZone).format('dddd');
                const dayData = item.has_many_cs_product_week_day.filter((dayitem) => dayitem.pwd_name === day);
                if (dayData.length > 0) {
                    return dayData[0].pwd_selling_price;
                } else {
                    return item.has_many_cs_product_week_day[0].pwd_selling_price;
                }
            }
        } else {
            return item.product_selling_price;
        }
    }

    const mrpPrice = (item) => {
        if (item.product_type === 1) {
            if (item.has_many_cs_product_week_day && item.has_many_cs_product_week_day.length > 0) {
                const day = moment().tz(timeZone).format('dddd');
                const dayData = item.has_many_cs_product_week_day.filter((dayitem) => dayitem.pwd_name === day);
                if (dayData.length > 0) {
                    return dayData[0].pwd_mrp;
                } else {
                    return item.has_many_cs_product_week_day[0].pwd_mrp;
                }
            }
        } else {
            return item.product_price;
        }
    }

    return (
        <>
            <AccountHeader heading={'Our Menu'}></AccountHeader>
            <div id="appCapsule">
                <div className="p-15">
                    <div className="row mb-20">
                        {isLoadingProducts ?
                            <div className="col-lg-12">
                                <div className="text-center mb-20">
                                    <h2><Skeleton width={160} height={30} /></h2>
                                    <p className="mb-0"><Skeleton width={120} height={15} /></p>
                                </div>
                                <div className="dpkuy-section">
                                    <div className="dpkuy">
                                        <div className="dpkuy-lable"></div>
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="col-lg-12">
                                <div className="text-center mb-20">
                                    <h2>Daadi's Kitchen</h2>
                                    <p className="mb-0">Delivery Fee Applies</p>
                                </div>
                                <div className="dpkuy-section">
                                    <div className="dpkuy">
                                        <div className={`dpkuy-lable ${contextValues.orderRecieveStatus === 'delivery' ? 'active' : ''}`} onClick={() => { onChangeRecieveStaus('delivery') }}>Delivery</div>
                                        <div className={`dpkuy-lable ${contextValues.orderRecieveStatus === 'pickup' ? 'active' : ''}`} onClick={() => { onChangeRecieveStaus('pickup') }}>Pickup</div>
                                    </div>
                                </div>
                            </div>
                        }
                        {isOrderStop && contextValues?.settingData?.order_stop_message && (<div className="container mt-3"><div className="alert alert-warning text-center mb-0" role="alert" style={{ whiteSpace: 'pre-line' }}>{contextValues.settingData.order_stop_message}</div></div>)}
                    </div>
                </div>
                {isLoadingProducts ?
                    <div className="menuboxsection" >
                        <div className="menuboxsection-header">
                            <h2 className="mb-0 title"><Skeleton width={150} height={30} /></h2>
                        </div>
                        <div className="meuSlider">
                            <div className="row">
                                {Array(2)
                                    .fill(0)
                                    .map((_, index) => (
                                        <div className="col-6" key={index}>
                                            <div className="feturesItems" key={index}>
                                                <div className="feturesItemsImg">
                                                    <Skeleton width={'100%'} height={'100%'} />
                                                </div>
                                                <div className="feturesItemsContent">
                                                    <h2 className="title"><Skeleton width={120} height={15} /></h2>
                                                    <div className="itemPrice mb-10">
                                                        <ins className="new-price">
                                                            <Skeleton width={50} height={15} />
                                                        </ins>
                                                    </div>
                                                    <Skeleton width={50} height={30} />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                    :
                    popularProduct?.length > 0 &&
                    <div className="menuboxsection menusLIDE" id="featuredItem" ref={featuredItemRef} >
                        <div className="menuboxsection-header menusLIDE-header" >
                            <h2 className="mb-0 title">Featured items</h2>
                            <div className='swiper-arrow menuswiperarrow'>
                                <div className="prev-arrow" onClick={handlePrevmob}><i className="ri-arrow-left-circle-line"></i></div>
                                <div className="next-arrow" onClick={handleNextmob}><i className="ri-arrow-right-circle-line"></i></div>
                            </div>
                        </div>
                        <div className="meuSlider">
                            <Swiper
                                spaceBetween={10}
                                slidesPerView={2.3}
                                pagination={{
                                    clickable: true,
                                }}
                                navigation={false}
                                ref={sliderProdmobRef}
                            >
                                {popularProduct?.map((item, popindex) => (
                                    <SwiperSlide key={popindex}>
                                        <div className="feturesItems">
                                            <div className="feturesItemsImg">
                                                <img src={item?.product_image ? item?.product_image : constants.Default_image} alt={item?.product_name} style={{ width: '100%' }}></img>
                                            </div>
                                            <div className="feturesItemsContent">
                                                <h2 className="title" >{item?.product_name}</h2>
                                                <div className="itemPrice mb-10">
                                                    {parseFloat(sellingPrice(item)) && (
                                                        <ins className="new-price">
                                                            ${parseFloat(sellingPrice(item))?.toFixed(2)}
                                                        </ins>
                                                    )}
                                                    {parseFloat(mrpPrice(item)) > parseFloat(sellingPrice(item)) && (
                                                        <del className="old-price">
                                                            ${parseFloat(mrpPrice(item))?.toFixed(2)}
                                                        </del>
                                                    )}
                                                </div>
                                                <div className="itemQty itemQtySmall">
                                                    {loadingItemId === item.product_id ? (
                                                        <span><Loader type="spinner-default" bgColor={'#db2727'} color={'#db2727'} size={20} /></span>
                                                    ) : (
                                                        <ItemButton
                                                            item={item}
                                                            cart={cart}
                                                            onModalOpen={onModalOpen}
                                                            updateCart={updateCartInSession}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                }
                {productData && productData?.length > 0 && (
                    <div className="menulistTabs"
                        style={{
                            display: ShowScroll ? 'block' : 'none',
                        }}
                    >
                        <Tabs activeTab={activeTab} onTabClick={handleTabClick}
                            hideNavBtnsOnMobile={false}
                        >
                            {productData?.map((item, proindex) => {
                                return (
                                    <Tab key={proindex}>
                                        {item?.cat_name}
                                    </Tab>
                                );
                            })}
                        </Tabs>
                    </div>
                )}
                {isLoading ?
                    <div className="menuboxsection" >
                        <div className="menuboxsection-header">
                            <h2 className="mb-0 title">
                                <Skeleton width="50%" />
                            </h2>
                        </div>
                        {Array(4)
                            .fill(0)
                            .map((_, productindex) => (
                                <div className="mitembox" key={productindex}>
                                    <div className="mitemboxContent">
                                        <h2 className="title">
                                            <Skeleton width="70%" />
                                        </h2>
                                        <p className="tx-14 sortdec tx-gray">
                                            <Skeleton width="90%" />
                                        </p>
                                        <div className="itemPrice">
                                            <Skeleton width={'50px'} />
                                            <Skeleton width={'50px'} />
                                        </div>
                                    </div>
                                    <div className="mitemboxMedia">
                                        <div className="mitemboxMediaimg">
                                            <Skeleton height={100} width={100} />
                                        </div>
                                        <div className="mitemsQty">
                                            <Skeleton width="50%" height={30} />
                                        </div>
                                        <div className="text-center tx-12 tx-gray mt-0">
                                            <Skeleton width="60%" />
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                    :
                    productData && productData.length > 0 && (
                        productData?.map((item, menuindex) => (
                            <div className="menuboxsection" key={menuindex}
                                data-index={menuindex}
                                ref={(el) => (sectionRefs.current[menuindex] = el)}
                            >
                                <div className="menuboxsection-header" key={menuindex}><h2 className="mb-0 title">{item?.cat_name}</h2></div>
                                {item?.products && item?.products?.length > 0 &&
                                    item?.products?.map((productitem, productindex) => (
                                        <div className="mitembox" key={productindex}>
                                            <div className="mitemboxContent">
                                                <h2 className="title">{productitem?.product_name}</h2>
                                                {productitem?.product_content && <p className="tx-14 sortdec tx-gray">{productitem?.product_content}</p>}

                                                <div className="itemPrice">
                                                    {parseFloat(sellingPrice(productitem)) && (
                                                        <ins className="new-price">
                                                            ${parseFloat(sellingPrice(productitem))?.toFixed(2)}
                                                        </ins>
                                                    )}
                                                    {parseFloat(mrpPrice(productitem)) > parseFloat(sellingPrice(productitem)) && (
                                                        <del className="old-price">
                                                            ${parseFloat(mrpPrice(productitem))?.toFixed(2)}
                                                        </del>
                                                    )}
                                                </div>
                                            </div>
                                            <div className="mitemboxMedia">
                                                <div className="mitemboxMediaimg">
                                                    <img src={productitem?.product_image ? productitem?.product_image : constants.Default_image} alt={productitem?.product_name}></img>
                                                </div>
                                                <div className="mitemsQty">
                                                    <div className="mitemcartqty">
                                                        {loadingItemId === productitem.product_id ? (
                                                            <span><Loader type="spinner-default" bgColor={'#db2727'} color={'#db2727'} size={20} /></span>
                                                        ) : (
                                                            <ItemButton
                                                                item={productitem}
                                                                cart={cart}
                                                                onModalOpen={onModalOpen}
                                                                updateCart={updateCartInSession}
                                                            />
                                                        )}
                                                    </div>
                                                </div>
                                                {productitem && productitem.product_type === 1 ?
                                                    <div className="text-center tx-12 tx-gray mt-0">customisable</div> : ''
                                                }
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        ))
                    )}
                {contextValues.cartCount && contextValues.cartCount > 0 ?
                    <div className="wapper-footer">
                        <button type="button" className="cfooterbutton" onClick={gotocheckout} >
                            <span>{contextValues.cartCount} Items added</span>
                            <span>View Cart <i className="ri-arrow-right-line"></i></span>
                        </button>
                    </div> : ''}

            </div>
            {contextValues.toggleItemAddModal && <AddItemModal></AddItemModal>}
            <div className={`rn-progress-parent ${active ? "rn-backto-top-active" : ""}`}
                onClick={scrollToTop}
            >
                <svg className="rn-back-circle svg-inner" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path
                        d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
                        style={{
                            transition: "stroke-dashoffset 30ms linear",
                            strokeDasharray: "307.919, 307.919",
                            strokeDashoffset: offset,
                        }}
                    />
                </svg>
            </div>
        </>
    )
}

export default OrderOnline